module.exports = __webpack_public_path__ + "media/mylittledinostartsound.c2e0763a.mp3";